<template>
  <el-dialog title="Linked Transaction No." :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <div class="pb20">
      <el-table border :data="relatedApplymentyList" size="mini" style="width: 100%">
        <el-table-column prop="applymentNo" align="center" label="Linked Transaction No." width="180" />
        <el-table-column prop="updateTime" align="center" label="Update Time" />
      </el-table>
    </div>
    <div class="pb20">
      <el-table border :data="relatedQuotationList" size="mini" style="width: 100%">
        <el-table-column prop="applymentNo" align="center" label="Linked Quotation No." width="180" />
        <el-table-column prop="updateTime" align="center" label="Update Time" />
      </el-table>
    </div>
    <div class="pb20">
      <el-table border :data="relatedAdjustmentList" size="mini" style="width: 100%">
        <el-table-column prop="adjustmentNo" align="center" label="Linked Quotation (V)" width="180" />
        <el-table-column prop="updateTime" align="center" label="Update Time" />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      relatedApplymentyList: [],
      relatedAdjustmentList: [],
      relatedQuotationList: [],
    };
  },
  methods: {
    // 初始化
    init(data) {
      this.visible = true;
      this.relatedApplymentyList = data.relatedApplymentyList || [];
      this.relatedAdjustmentList = data.relatedAdjustmentList || [];
      this.relatedQuotationList = data.relatedQuotationList || [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
